import { useMutation } from 'react-query'
import { notificationUseCase } from '../../factories'

const useUpdateNotification = () => useMutation(notificationUseCase.updateNotification)

export default useUpdateNotification
